<template>
    <div>
        <!-- START NAVBAR -->
        <nav id="navbar" class="navbar navbar-expand-lg fixed-top sticky">
            <div class="container">
                <a class="navbar-brand" href="">
                    <img src="../../assets/svgs/logo.svg" class="logo-light-mode" alt="">
                    <!-- <img src="../../assets/images/logo-light.png" class="logo-dark-mode" alt=""> -->
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation" @click="handler">
                    <i data-feather="menu"></i>
                </button>

                <div class="collapse navbar-collapse" :class="{ hidden: !toggle }" id="navbarSupportedContent">
                    <ul class="navbar-nav mx-auto mb-2 mb-lg-0" id="navbar-navlist">
                        <li class="nav-item mx-2" :class="{ active: $route.path === '/' }">
                            <a class="nav-link" href="/" @click="closeMenu">Home</a>
                        </li>
                        <li class="nav-item mx-2" :class="{ active: $route.path === '/contact' }">
                            <router-link class="nav-link" to="/contact" @click="closeMenu">Contact Us</router-link>
                        </li>
                        <li class="nav-item mx-2">
                            <a class="nav-link" href="https://docs.taficloud.com" target="_blank" @click="closeMenu">Docs</a>
                        </li>
                    </ul>
                </div>

                <!-- Desktop CTA button (only visible on desktop) -->
                <div class="d-none d-lg-block">
                    <a href="https://dashboard.taficloud.com/" class="btn btn-primary">Get Started</a>
                </div>
            </div>
            <!--end container-->
        </nav>
        <!-- END NAVBAR -->
    </div>
</template>

<script>
import feather from 'feather-icons';

export default {
    name: "navbarVue",
    components: {

    },
    data() {
        return {
            toggle: false,
            scroll: true,
            sections: document.querySelectorAll("section"),
            navLi: document.querySelectorAll("nav .container .collapse ul li"),
            current: "",
            sectionTop: null,
        }
    },
    computed: {
        isMobileMenuOpen() {
            // Check if we're on mobile and menu is toggled
            return window.innerWidth < 900;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('scroll', this.onscroll);
        feather.replace()
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('scroll', this.onscroll);
    },

    methods: {
        handler: function () {
            this.toggle = !this.toggle;
        },
        
        closeMenu: function() {
            this.toggle = false;
        },

        handleScroll() {
            const navbar = document.getElementById("navbar");
            if (
                document.body.scrollTop >= 50 ||
                document.documentElement.scrollTop >= 50
            ) {
                navbar.classList.add("nav-sticky");
            } else {
                navbar.classList.remove("nav-sticky");
            }
        },

        onscroll() {
            document.querySelectorAll("section").forEach((section) => {
                this.sectionTop = section.offsetTop;
                if (pageYOffset >= this.sectionTop - 60) {
                    this.current = section.getAttribute("id");
                }
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.mobile-cta {
    margin-left: 10px;
}

#navbar {
    transition: all 0.3s ease;
    background-color: transparent;
}

.nav-sticky {
    background-color: rgba(255, 255, 255, 0.85) !important;
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

@media (max-width: 991px) {
    .navbar-collapse {
        position: absolute;
        top: 60px;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        padding: 15px;
        box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
        z-index: 999;
        
        .navbar-nav {
            margin: 0 auto;
        }
    }
    
    .nav-sticky {
        background-color: rgba(255, 255, 255, 0.95) !important;
    }
}
</style>